const ChatsIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 0.75H9.625C10.582 0.75 11.375 1.54297 11.375 2.5V7.75C11.375 8.73438 10.582 9.5 9.625 9.5H5.52344L3.30859 11.168C3.17188 11.2773 3.00781 11.2773 2.84375 11.2227C2.70703 11.1406 2.625 11.0039 2.625 10.8125V9.5H1.75C0.765625 9.5 0 8.73438 0 7.75V2.5C0 1.54297 0.765625 0.75 1.75 0.75ZM9.625 10.375C11.0742 10.375 12.25 9.19922 12.25 7.75V4.25H15.75C16.707 4.25 17.5 5.04297 17.5 6V11.25C17.5 12.2344 16.707 13 15.75 13H14.875V14.3125C14.875 14.5039 14.7656 14.6406 14.6289 14.7227C14.4648 14.7773 14.3008 14.7773 14.1641 14.668L11.9492 13H8.75C7.76562 13 7 12.2344 7 11.25V10.375H9.625Z"
      fill="#7464B2"
    ></path>
  </svg>
);

export default ChatsIcon;